var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcFolderOutlineWhite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "27px",
    height: "23px",
    viewBox: "0 0 27 23",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icFoldder") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M2.4821727,22.4 L24.1178273,22.4 C25.4885794,22.4 26.6,21.28 26.6,19.8986667 L26.6,6.608 C26.6,5.22666667 25.4885794,4.10666667 24.1178273,4.10666667 L14.3373259,4.10666667 C14.0038997,4.10666667 13.7075209,3.99466667 13.4852368,3.77066667 L9.89164345,0.634666667 C9.41002786,0.186666667 8.85431755,0 8.26155989,0 L2.4821727,0 C1.11142061,0 0,1.12 0,2.50133333 L0,19.8986667 C-6.58093202e-16,21.28 1.11142061,22.4 2.4821727,22.4 Z M1.4,2.69529981 C1.4,1.96531844 1.9804878,1.38133333 2.70609756,1.38133333 L8.36585366,1.38133333 C8.69237805,1.38133333 8.98262195,1.49083054 9.20030488,1.70982495 L12.7195122,4.77574674 C13.154878,5.1772365 13.7353659,5.35973184 14.3158537,5.35973184 L23.8939024,5.35973184 C24.6195122,5.35973184 25.2,5.94371695 25.2,6.67369832 L25.2,19.6673669 C25.2,20.3973482 24.6195122,20.9813333 23.8939024,20.9813333 L2.70609756,20.9813333 C1.9804878,20.9813333 1.4,20.3973482 1.4,19.6673669 C1.4,19.7038659 1.4,2.69529981 1.4,2.69529981 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Private-Album-1-selected-Copy-3",
    transform: "translate(-20.000000, -508.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "colour/black",
    transform: "translate(20.200000, 508.300000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "icFoldder",
    fill: "#fff",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFolderOutlineWhite);
export default __webpack_public_path__ + "static/media/icFolderOutlineWhite.7b170f2fce44a75ea55233ede1b60254.svg";
export { ForwardRef as ReactComponent };